import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Navigation from "./components/Navigation";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import GalleryPage from "./pages/GalleryPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import BookingPage from "./pages/BookingPage";
import ContactPage from "./pages/ContactPage";
import Footer from "./pages/Footer";
import Banner from "./pages/Banner";
import { CartProvider } from "./context/CartContext";
import OurTeamPage from "./pages/OurTeam";
import BookingSuccessPage from "./pages/BookingSucess";
import BookingFailPage from "./pages/BookingFail";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import ConsentForm from "./pages/ConsentForm";

const theme = createTheme({
  palette: {
    primary: {
      main: "#a67c5b",
    },
    secondary: {
      main: "#2c3e50",
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 300,
    },
    h2: {
      fontWeight: 300,
    },
    h3: {
      fontWeight: 400,
    },
    h4: {
      fontWeight: 400,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CartProvider>
        <CssBaseline />
        <Router>
          <ScrollToTop />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/ourteam" element={<OurTeamPage />} />
              <Route path="/booking-success" element={<BookingSuccessPage />} />
              <Route path="/booking-fail" element={<BookingFailPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/consent-form" element={<ConsentForm />} />
            </Routes>
          </main>
          <Banner />
          <Footer />
        </Router>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
